/** Normaliza texto para busca (minúsculas, sem acentos). */
// eslint-disable-next-line import/prefer-default-export
export function normalizeSearchText(text: string): string {
  return (text || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
